module.exports = __webpack_public_path__ + "static/store2-58d4e1187cdb8b0dea649836676812e4.jpg";